import type { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import type { RootState } from '@/store';
import { actionNames, getterNames, mutationNames, namespace } from './types';
import {
    ApiException,
    AssessorClientInstance,
    AssessorProfileDto,
} from '@/api';

const state = {
    profile: null as AssessorProfileDto | null,
    loading: false,
    error: null as ApiException | null,
};

export type AssessorState = typeof state;

const getters: GetterTree<AssessorState, RootState> = {
    [getterNames.getProfile]: (state) => state.profile,
    [getterNames.loading]: (state) => state.loading,
};

const mutations: MutationTree<AssessorState> = {
    [mutationNames.setProfile](state, profile: AssessorProfileDto) {
        state.profile = profile;
    },
    [mutationNames.setLoading](state, loading: boolean) {
        state.loading = loading;
    },
    [mutationNames.setError](state, error: ApiException) {
        state.error = error;
    },
};

const actions: ActionTree<AssessorState, RootState> = {
    async [actionNames.fetchMyProfile](context) {
        try {
            context.commit(mutationNames.setLoading, true);
            const profile = await AssessorClientInstance.me();
            context.commit(mutationNames.setProfile, profile);
        } catch (e) {
            context.commit(mutationNames.setError, e);
        } finally {
            context.commit(mutationNames.setLoading, false);
        }
    },
};

const module: Module<AssessorState, RootState> = {
    state: () => state,
    getters,
    mutations,
    actions,
    namespaced: true,
};

export { namespace, getterNames, actionNames, mutationNames };
export default module;
